import Environment from '../lib/Environment';
import XhrRequestHandler from '../lib/XhrRequestHandler';
import XhrRequestCache from '../lib/XhrRequestCache';
import XhrErrorListener from '../lib/XhrErrorListener';
import { PartidoSystem } from './Partido/PartidoSystem';
import { UsuarioJSON, Usuario } from './Usuario/Usuario';
import { PlanillaPartidoSystem } from './PlanillaPartido/PlanillaPartidoSystem';
import { ArbitroSystem } from './Arbitro/ArbitroSystem';
import { ArbitroParejaSystem } from './ArbitroPareja/ArbitroParejaSystem';
import { CampoJuegoSystem } from './CampoJuego/CampoJuegoSystem';
import { JugadorSystem } from './Jugador/JugadorSystem';
import { EntrenadorSystem } from './Entrenador/EntrenadorSystem';
import { OficialMesaSystem } from './OficialMesa/OficialMesaSystem';
import { FederacionSystem } from './Federacion/FederacionSystem';
import { ClubSystem } from './Club/ClubSystem';
import { EventoXPlanillaSystem } from './EventoXPlanilla/EventoXPlanillaSystem';
import { TipoEventoPlanillaSystem } from './TipoEventoPlanilla/TipoEventoPlanillaSystem';
import { CategoriaSystem } from './Categoria/CategoriaSystem';
import { PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorSystem } from './PlanillaPartidoReglaJugadorDisponibleCategoriasInferior/PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorSystem';
import { PlanillaPartidoEnVivoSystem } from './PlanillaPartidoEnVivo/PlanillaPartidoEnVivoSystem';
import { TimeoutXPlanillaSystem } from './TimeoutXPlanilla/TimeoutXPlanillaSystem';
import { PlanillaPartidoJugadorSystem } from './PlanillaPartidoJugador/PlanillaPartidoJugadorSystem';
import { FederacionGestionAccionSystem } from './FederacionGestionAccion/FederacionGestionAccionSystem';
class SystemClient {
  private partidoSystem: PartidoSystem;
  private planillaPartidoSystem: PlanillaPartidoSystem;
  private planillaPartidoEnVivoSystem: PlanillaPartidoEnVivoSystem;
  private arbitroSystem: ArbitroSystem;
  private arbitroParejaSystem: ArbitroParejaSystem;
  private campoJuegoSystem: CampoJuegoSystem;
  private jugadorSystem: JugadorSystem;
  private entrenadorSystem: EntrenadorSystem;
  private federacionSystem: FederacionSystem;
  private oficialMesaSystem: OficialMesaSystem;
  private clubSystem: ClubSystem;
  private eventoXPlanillaSystem: EventoXPlanillaSystem;
  private timeoutXPlanillaSystem: TimeoutXPlanillaSystem;
  private tipoEventoPlanillaSystem: TipoEventoPlanillaSystem;
  private categoriaSystem: CategoriaSystem;
  private planillaPartidoReglaJugadorDisponibleCategoriasInferiorSystem: PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorSystem;
  private planillaPartidoJugadorSystem: PlanillaPartidoJugadorSystem;
  private federacionGestionAccion: FederacionGestionAccionSystem;
  private loginBase: string = '/loginDVM';

  private constructor(private requestHandler: XhrRequestHandler) {
    this.partidoSystem = new PartidoSystem(this.requestHandler);
    this.planillaPartidoSystem = new PlanillaPartidoSystem(this.requestHandler);
    this.planillaPartidoEnVivoSystem = new PlanillaPartidoEnVivoSystem(this.requestHandler);
    this.arbitroSystem = new ArbitroSystem(this.requestHandler);
        this.arbitroParejaSystem = new ArbitroParejaSystem(this.requestHandler);
    this.campoJuegoSystem = new CampoJuegoSystem(this.requestHandler);
    this.federacionSystem = new FederacionSystem(this.requestHandler);
    this.jugadorSystem = new JugadorSystem(this.requestHandler);
    this.entrenadorSystem = new EntrenadorSystem(this.requestHandler);
    this.eventoXPlanillaSystem = new EventoXPlanillaSystem(this.requestHandler);
    this.timeoutXPlanillaSystem = new TimeoutXPlanillaSystem(this.requestHandler);
    this.oficialMesaSystem = new OficialMesaSystem(this.requestHandler);
    this.clubSystem = new ClubSystem(this.requestHandler);
    this.tipoEventoPlanillaSystem = new TipoEventoPlanillaSystem(this.requestHandler);
    this.categoriaSystem = new CategoriaSystem(this.requestHandler);
    this.planillaPartidoReglaJugadorDisponibleCategoriasInferiorSystem =
      new PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorSystem(this.requestHandler);
    this.planillaPartidoJugadorSystem = new PlanillaPartidoJugadorSystem(this.requestHandler);
    this.federacionGestionAccion = new FederacionGestionAccionSystem(this.requestHandler);
  }

  static start(environment: Environment) {
    const requestHandler = new XhrRequestHandler(environment, XhrRequestCache.with([]));

    return new this(requestHandler);
  }

  getFederacionGestionAccionSystem(): FederacionGestionAccionSystem {
    return this.federacionGestionAccion;
  }

  getPlanillaPartidoSystem(): PlanillaPartidoSystem {
    return this.planillaPartidoSystem;
  }

  getPlanillaPartidoEnVivoSystem(): PlanillaPartidoEnVivoSystem {
    return this.planillaPartidoEnVivoSystem;
  }

  getFederacionSystem(): FederacionSystem {
    return this.federacionSystem;
  }

  getEventoXPlanillaSystem(): EventoXPlanillaSystem {
    return this.eventoXPlanillaSystem;
  }

  getTimeoutXPlanillaSystem(): TimeoutXPlanillaSystem {
    return this.timeoutXPlanillaSystem;
  }

  getPartidoSystem(): PartidoSystem {
    return this.partidoSystem;
  }
  getArbitroSystem(): ArbitroSystem {
    return this.arbitroSystem;
  }
  getArbitroParejaSystem(): ArbitroParejaSystem {
return this.arbitroParejaSystem;}
  getCampoJuegoSystem(): CampoJuegoSystem {
    return this.campoJuegoSystem;
  }
  getJugadorSystem(): JugadorSystem {
    return this.jugadorSystem;
  }
  getEntrenadorSystem(): EntrenadorSystem {
    return this.entrenadorSystem;
  }
  getOficialMesaSystem(): OficialMesaSystem {
    return this.oficialMesaSystem;
  }
  getClubSystem(): ClubSystem {
    return this.clubSystem;
  }
  getTipoEventoPlanillaSystem(): TipoEventoPlanillaSystem {
    return this.tipoEventoPlanillaSystem;
  }
  getCategoriaSystem(): CategoriaSystem {
    return this.categoriaSystem;
  }
  getPlanillaPartidoReglaJugadorDisponibleCategoriasInferiorSystem(): PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorSystem {
    return this.planillaPartidoReglaJugadorDisponibleCategoriasInferiorSystem;
  }
  getPlanillaPartidoJugadorSystem(): PlanillaPartidoJugadorSystem {
    return this.planillaPartidoJugadorSystem;
  }

  async userData() {
    const us = await this.requestHandler.get<UsuarioJSON>(`${this.loginBase}/user-data`);
    return Usuario.fromJSON(us);
  }

  async logout() {
    var urlReturn = window.location.protocol + '//' + window.location.host + '/';
    const data = await this.requestHandler.get<{ redirectTo: string }>(
      `${this.loginBase}/logout?return_to=${urlReturn}`
    );
    window.location.href = data.redirectTo;
  }

  getPublicKey() {
    return this.requestHandler.get<string>(`/.well-known/public_key.pem`);
  }

  unsubscribe(aListener: XhrErrorListener) {
    return this.requestHandler.unsubscribe(aListener);
  }

  subscribe(aListener: XhrErrorListener) {
    return this.requestHandler.subscribe(aListener);
  }
}

export default SystemClient;
